export class UpdateSourceAccountResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceAccount",
            "baseName": "sourceAccount",
            "type": "SourceAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSourceAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
